// extracted by mini-css-extract-plugin
export default {"component-error":"component-error_component-error__aQ0tW","component-error__text":"component-error_component-error__text__yTO3K"};